import React from 'react'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import qs from 'qs';
import buscarPedido from '../../actions/pedido/buscarPedido';
import Titulo from '../comum/Titulo';
import ModalImpressaoReciboPassageiro from './ModalImpressaoReciboPassageiro';
import {showErrorMsg} from '../../util/messagesUtil';
import ReciboPassagem from './ReciboPassagem';
import { EMPRESAS_NAO_EXIBIR_DIREITOS_DEVERES } from '../../util/constantsUtil';
import cadastrarComissaoReimpressaoRecibo from '../../actions/pedido/cadastrarComissaoReimpressaoRecibo';

export class PainelReciboPassagem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            referencias: null,
            paginaRetorno: '/painel-vendas',            
            referenciaSelecionada: null
        }
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, {ignoreQueryPrefix: true});
        if (this.props.empresaSelecionada.id) {
            if (parametros.paginaRetorno) {
                this.setState({paginaRetorno: parametros.paginaRetorno})
            }
            if (parametros.pedido) {
                this.props.buscarPedido(parametros.pedido, this.props.empresaSelecionada.id)
                    .then(() => {
                        if (!this.props.pedido) {
                            showErrorMsg('Pedido não encontrato.');
                            this.props.history.push('/painel-vendas');
                            return
                        }
                        const qtdEmbarcado = this.props.pedido.reservas.filter(it => it.dataHoraEmbarque != null).length

                        if(qtdEmbarcado === this.props.pedido.reservas.length){
                            showErrorMsg('Todas as reservas já foram embarcadas.');
                            this.props.history.push('/painel-vendas')
                        }
                        if (this.props.pedido.ultimoHistorico.situacaoPedido === 'CANCELADO' ||
                            this.props.pedido.ultimoHistorico.situacaoPedido === 'REMARCADO') {
                            showErrorMsg('Pedido cancelado ou remarcado.');
                            this.props.history.push('/painel-vendas')
                        }
                        this.gerarReferencias()
                    })
            } else {
                this.props.history.push('/painel-vendas')
            }
        }

    }

    seCompradorPassageiro() {
        return this.props.pedido.reservas.filter(it => it.passageiroDto.cpfPassageiro === this.props.pedido.cpfCnpjComprador).length > 0
    }

    agrupadoPorCPFPassageiro(dados) {
        return dados.reduce((acc, item) => {
            const cpf = item.passageiroDto.cpfPassageiro;
            if (!acc[cpf]) {
            acc[cpf] = [];
            }
            acc[cpf].push(item);
            return acc;
        }, {});
    }
      

    gerarReferencias() {
        const ref = new Map();
        if (!EMPRESAS_NAO_EXIBIR_DIREITOS_DEVERES.includes(this.props.empresaSelecionada.id)) {
            ref.set('DIREITOS_DEVERES', {
                id: 'direitos_deveres',
                nome: 'Direitos e Deveres',
                nomeParaImpressao: 'Direitos e Deveres',
                referencia: React.createRef()
            })
        }
        ref.set('AGENCIA', {
            id: 'agencia',
            nome: 'Via de controle da agência',
            nomeParaImpressao: `Pedido ${this.props.pedido.id} - Via de controle da agẽncia`,
            referencia: React.createRef()
        });
        if (!this.seCompradorPassageiro()) {
            ref.set('COMPRADOR', {
                id: 'comprador',
                nome: 'Via do comprador',
                nomeParaImpressao: `Pedido ${this.props.pedido.id} - Via do comprador`,
                referencia: React.createRef()
            })
        }
        ref.set('TODOS_PASSAGEIROS', {
            id: 'todos',
            nome: 'Todas as vias dos passageiros',
            nomeParaImpressao: `Pedido ${this.props.pedido.id} - Todas as vias dos passageiros`,
            referencia: React.createRef()
        });
        const reservas = this.props.pedido.reservas.filter(r => r.situacaoReserva === 'APROVADO' && r.dataHoraEmbarque === null)
            .sort((a, b) => {
                if (a.passageiroDto.cpfPassageiro === b.passageiroDto.cpfPassageiro) {
                    if (a.rotaId === b.rotaId) {
                        return a.ordemTrechoOrigem - b.ordemTrechoOrigem;
                    }
                    return a.rotaId - b.rotaId;
                }
                return a.passageiroDto.cpfPassageiro.localeCompare(b.passageiroDto.cpfPassageiro);
            });
        reservas.forEach((reserva) => {
            ref.set(`PASSAGEIRO${reserva.passageiroDto.id}`, {
                id: `passageiro${reserva.passageiroDto.id}`,
                nome: reserva.passageiroDto.nome,
                nomeParaImpressao: reserva.passageiroDto.nome,
                trecho: `${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}`,
                referencia: React.createRef()
            });
            if (reserva.passageiroDto.criancaDto) {
                ref.set(`CRIANCA${reserva.passageiroDto.id}`, {
                    id: `crianca${reserva.passageiroDto.id}`,
                    nome: reserva.passageiroDto.criancaDto.nome,
                    nomeParaImpressao: reserva.passageiroDto.criancaDto.nome,
                    trecho: `${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}`,
                    referencia: React.createRef()
                })
            }
        });
        const agrupadoPorCPF = this.agrupadoPorCPFPassageiro(reservas);        
        for (const cpf in agrupadoPorCPF) {            
            ref.set(`RESUMO_CUPOM${cpf}`, {
                id: `RESUMO_CUPOM${cpf}`,
                nome: `Resumo Cupom ${agrupadoPorCPF[cpf][0].passageiroDto.nome}`,
                nomeParaImpressao: `Resumo Cupom ${agrupadoPorCPF[cpf][0].passageiroDto.nome}`,
                referencia: React.createRef()
            });
        }
        
        this.setState({referencias: ref})
    }

    limparMensagem() {
        this.setState({mensagem: undefined})
    }

    limparFormulario() {
        this.props.reset('formReserva');
        this.limparMensagem();
    }

    fecharModal() {
        this.props.reset('formReserva');
        this.props.selecionarPedido(null);
    }

    exibirBotaoImprimir() {
        return (
            <React.Fragment>
                <a target="_BLANK" style={{cursor: 'pointer'}} data-toggle="modal"
                   data-target="#modalImpressaoReciboPassageiro" className="btn btn-laranja">
                    <i className="material-icons mr-1" style={{
                        fontSize: '18px',
                        verticalAlign: 'middle'
                    }}>
                        &#xe8ad;
                    </i>
                    Imprimir
                </a>
            </React.Fragment>)
    }

    checkReferenciaSelecionada(referenciaSelecionada) {
        this.setState({ referenciaSelecionada })
    }

    render() {
        if (!this.props.pedido || !this.state.referencias) {
            return ''
        }
        return (
            <React.Fragment>
                <div className="row internas col-md-12 d-flex justify-content-center mb-2">
                    <Titulo texto="Recibo de compra" urlRetorno={this.state.paginaRetorno}/>
                    <div className='col-md-12 d-flex justify-content-center mb-2'>
                        {this.exibirBotaoImprimir()}
                    </div>
                    <div className="printer-ticket">
                        <ReciboPassagem modoImpressaoSimplificado={false} referencias={this.state.referencias} pedido={this.props.pedido} referenciaSelecionada={this.state.referenciaSelecionada} />
                    </div>
                </div>
                <ModalImpressaoReciboPassageiro
                    pedido={this.props.pedido}
                    empresaSelecionada={this.props.empresaSelecionada}
                    referencias={this.state.referencias} 
                    checkReferenciaSelecionada={this.checkReferenciaSelecionada.bind(this)} 
                    cadastrarComissaoReimpressaoRecibo={this.props.cadastrarComissaoReimpressaoRecibo}
                />
            </React.Fragment>
        )
    }
}

export function mapStateToProps(state) {
    return {
        pedido: state.pedido,
        empresaSelecionada: state.empresaSelecionada
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        buscarPedido,
        cadastrarComissaoReimpressaoRecibo
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formReserva',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(PainelReciboPassagem));
